import React, { useEffect, useRef, useState } from 'react';
import { useNotificationMessage } from '../common/notification/message.hook';
import { apiUnfollowJourney } from '../utils/journeyApi';
import { Redirect, useParams } from 'react-router-dom';

const JourneyUnfollow = () => {
  const { journeyID } = useParams();
  const isMountRef = useRef(false);
  const [isRequestComplete, setIsRequestComplete] = useState(false);
  const { setSuccessNotification, setErrorNotification } = useNotificationMessage();

  useEffect(() => {
    if (!isMountRef.current) {
      (async () => {
        try {
          await apiUnfollowJourney(journeyID);
          setSuccessNotification('Journey Unfollowed');
        } catch (err) {
          setErrorNotification(err.message);
        } finally {
          setIsRequestComplete(true);
        }
      })();
    }
    isMountRef.current = true;
  }, [journeyID, setErrorNotification, setSuccessNotification]);

  if (!isRequestComplete) return null;

  return <Redirect to='/journeys' />;
};

export default JourneyUnfollow;
